import React, { Component } from 'react';
import { Card, WhiteSpace } from 'antd-mobile';
import { navigateTo } from 'common/util';
import CardHeader from './cardHeader';
import CardBody from './cardBody';
import CardFooter from './cardFooter';
import "./index.less";

export default class MaterialCard extends Component {
    constructor(props) {
        super(props);
        const { item } = props;
        this.state = {
            materialData : item
        }
    }

    pageTo = ( stockorgId, deliveryId ) => {
        let getUrl = currentPage => {
            currentPage = currentPage || ''
            return `/detail${currentPage}?stockorgId=${stockorgId}&deliveryId=${deliveryId}`
        }
        console.log('run')
        navigateTo({
            path: getUrl(),
            url: `/pages${getUrl('/index')}`,
        })
    }

    render() {
        const { materialData } = this.state;
        const { type } = this.props;

        // 从返回的数据拿到 车牌号，订单编号，提送货日期，提送货类型，发货组织，送货PK，送货信息
        const { vlicense, vbillcode, dbilldate, vbilltypecode, stockorg, pk_delivery, deliveryBodys, lineStatus, fstatusflag } = materialData;
        let pk_stockorg = stockorg.pk_org;

        let stepType = 'cardStep'; //给个标识
        return (
            <div className="list-card">
                <WhiteSpace/>
                <Card onClick={() => { this.pageTo( pk_stockorg, pk_delivery) }}>
                    <CardHeader
                        vlicense = { vlicense }
                        vbillcode = { vbillcode }
                    />
                    <Card.Body>
                        <CardBody
                            type = { type }
                            vbilltypecode = { vbilltypecode }
                            dbilldate = { dbilldate }
                            deliveryBodys = { deliveryBodys }
                            lineStatus = { lineStatus }
                            fstatusflag = { fstatusflag }
                        ></CardBody>
                    </Card.Body>
                    {
                        (type === 'backlog' && (lineStatus?.code === "1" || lineStatus?.code === "2"))
                            ? <CardFooter currentStatusCode={lineStatus?.code} stepType={stepType}></CardFooter>
                            : <div></div>
                    }
                </Card>
            </div>
        )
    }
}
